import * as types from './types'

export default {
  [types.MUTATE_REQUESTS_SEARCH_RESULT]: (state, payload) => {
    state.requestsSearchResult = payload
  },
  [types.MUTATE_REQUEST_SIDEBAR]: (state, payload) => {
    state.requestSidebar = { ...state.requestSidebar, ...payload }
  },
  [types.MUTATE_APPROVERS_SEARCH_RESULT]: (state, payload) => {
    state.approversSearchResult = payload
  },
  [types.MUTATE_APPROVER_SIDEBAR]: (state, payload) => {
    state.approverSidebar = { ...state.approverSidebar, ...payload }
  },
}
